module.exports = __webpack_public_path__ + "static/media/option2_step2_blue_new_he.4ed23233.png";